import { useState } from 'react'

import { LazyImageObject, LazyImagePlaceholder, LazyImageWrapper } from './LazyImage.styles.js'

const LazyImage = ({ src }) => {
  const [isLoaded, setIsLoaded] = useState(false)

  // useEffect(() => {
  //   console.log(isLoaded)
  // }, [isLoaded])

  return (
    <LazyImageWrapper>
      {<LazyImagePlaceholder src={require('@/assets/img/product-default.jpg')} />}
      {src && <LazyImageObject src={src} onLoad={() => setIsLoaded(true)} isLoaded={isLoaded} />}
    </LazyImageWrapper>
  )
}

export default LazyImage
